app.controller('CIF2-CTRL', ['$scope','$rootScope','$http', '$window', '$q', '$filter', 'appFactory',
    function ($scope,$rootScope,$http, $window, $q, $filter, appFactory) {

    $scope.listBankRDN = ['BCA (Online)', 'MANDIRI (Offline)', 'CIMB (Offline)', 'MAYAPADA (Offline)'];
    $scope.rdnbca = $scope.listBankRDN[0];
    $scope.bankRDN = '';
    $scope.PhoneCode = '+62';
    $scope.CIFInvestor = {}
    $scope.bankpribadi = '';
    $scope.SpouseKewarganegaraan = 'WNI / Indonesian';
    $scope.SpouseKewarganegaraanOption = ['WNI / Indonesian', 'Lainnya / Others'];
    $scope.chkSpouseSeumurHidup = true;
    $scope.disabledNPWPNumber = false;

    $scope.OPBBCA = {
        occupation: '',
        occupationText: '',
        position: '',
        positionText: '',
        business: '',
        businessText: ''
    }

    $scope.OPCIMB = {
        occupation: '',
        position: '',
        business: ''
    }

    $scope.OPBOTHER = {
        occupation: '',
        occupationText: '',
        position: '',
        positionText: '',
        business: '',
        businessText: ''
    }

    $scope.OPSPOUSE = {
        occupation: '',
        occupationText: '',
        position: '',
        business: '',
    }

    $scope.disableBank = true;
    $scope.disableCIFInvestorQuestionRDN = false;
    $scope.MandatoryBRI = false;

    $scope.selectedFundSource = [];
    $scope.selectedSpouseFundSource = [];

    $scope.ListBank = {};
    $scope.listpekerjaan_BCA = {};
    $scope.listjabatan_BCA = {};
    $scope.listusaha_BCA = {};
    $scope.ListLookup = [];
    $scope.ListOccupation = [];
    $scope.ListSpouseIncome = [];
    $scope.ListKecamatanSpouse = [];
    $scope.ListKelurahanSpouse = [];
    $scope.ListKecamatanCompany = [];
    $scope.ListKelurahanCompany = [];

    $scope.ListBRILookup = [];

    $scope.listpekerjaan_CIMB = {};
    $scope.listposition_CIMB = {};
    $scope.listnature_CIMB = {};

    $scope.CompanyCitySelected = '';
    $scope.SpouseCompanyCitySelected = '';
    $scope.SpouseIDCardCitySelected = '';
    $scope.mustSelect = function (event, field) {

        if (event.keyCode == 27) {

            let returnValue = true;
            switch (field) {

                case 'IDCard': $scope.CIFInvestor.SpouseIDCardCity = ''; returnValue = false;
                    break;
                case 'Company': $scope.CIFInvestor.CompanyCity = ''; returnValue = false;
                    break;
                default:
                    break;
            }
            return returnValue;
        }
        return true;
    }
    $scope.selectCity = function (item, model, label, event) {

        if (item.CIFProvinceCityNID) {

            $scope.CIFInvestor.SpouseCompanyCity = item.CIFProvinceCityNID;
        }
    };

    $scope.selectIDCardCitySpouse = function (item, model, label, event) {
        $scope.ListKecamatanSpouse = '';
        $scope.ListKelurahanSpouse = '';

        if (item.CIFProvinceCityNID) {

            $scope.CIFInvestor.SpouseIDCardCity = item.CIFProvinceCityNID;

            if ($scope.CIFInvestor.QuestionRDN == 1 || $scope.CIFInvestor.QuestionRDN == 4) {
                appFactory.getData(`/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=${item.CIFProvinceCityNID}`).then(function (data) {

                    if (data.status == 200) {

                        $scope.ListKecamatanSpouse = data.data.d;
                        $scope.kecamatanChangeSpouse();
                    }
                });
            }

            if ($scope.CIFInvestor.QuestionRDN == 9) {
                appFactory.getData(`/service/client.svc/GetCIFKecamatanCIMBByCityNID?CIFCityNID=${item.CIFProvinceCityNID}`).then(function (data) {

                    if (data.status == 200) {

                        $scope.ListKecamatanSpouse = data.data.d;
                        $scope.kecamatanChangeSpouse();
                    }
                });
            }
           
        }

    };

    $scope.selectCityCompany = function (item, model, label, event) {
        $scope.ListKecamatanCompany = '';
        $scope.ListKelurahanCompany = '';

        if (item.CIFProvinceCityNID) {

            $scope.CIFInvestor.CompanyCity = item.CIFProvinceCityNID;

            if ($scope.CIFInvestor.QuestionRDN == 1 || $scope.CIFInvestor.QuestionRDN == 4) {
                appFactory.getData(`/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=${item.CIFProvinceCityNID}`).then(function (data) {

                    if (data.status == 200) {

                        $scope.ListKecamatanCompany = data.data.d;
                        $scope.kecamatanChangeCompany();
                    }
                });
            }

            if ($scope.CIFInvestor.QuestionRDN == 9) {
                appFactory.getData(`/service/client.svc/GetCIFKecamatanCIMBByCityNID?CIFCityNID=${item.CIFProvinceCityNID}`).then(function (data) {

                    if (data.status == 200) {

                        $scope.ListKecamatanCompany = data.data.d;
                        $scope.kecamatanChangeCompany();
                    }
                });
            }
           
        }

    };

    $scope.selectSpouseNationality = function (item, model, label, event) {
        if (item.CIFCountryNID) {

            $scope.CIFInvestor.SpouseNationality = item.CIFCountryNID;
            $scope.SpouseNationalitySelected = item;
        }
    };

    $scope.kecamatanChangeSpouse = function () {

        if ($scope.CIFInvestor.SpouseIDCardKecamatan)
            $scope.ListKelurahanSpouse = $filter('filter')($scope.ListKecamatanSpouse, { Kecamatan: $scope.CIFInvestor.SpouseIDCardKecamatan }, true);
    }

    $scope.kelurahanChangeSpouse = function () {

        if ($scope.CIFInvestor.SpouseIDCardKelurahan) {

            let temp = $filter('filter')($scope.ListKecamatanSpouse, { Kelurahan: $scope.CIFInvestor.SpouseIDCardKelurahan }, true);
            if (temp)
                $scope.CIFInvestor.SpouseIDCardPostalCode = temp[0].PostalCode;

        }
    }

    $scope.kecamatanChangeCompany = function () {

        if ($scope.CIFInvestor.CompanyKecamatan)
            $scope.ListKelurahanCompany = $filter('filter')($scope.ListKecamatanCompany, { Kecamatan: $scope.CIFInvestor.CompanyKecamatan }, true);
    }

    $scope.kelurahanChangeCompany = function () {

        if ($scope.CIFInvestor.CompanyKelurahan) {

            let temp = $filter('filter')($scope.ListKecamatanCompany, { Kelurahan: $scope.CIFInvestor.CompanyKelurahan }, true);
            if (temp)
                $scope.CIFInvestor.CompanyPostalCode = temp[0].PostalCode;

        }
    }

    $scope.SpouseKewarganegaraanChange = function () {

        if ($scope.SpouseKewarganegaraan == 'WNI / Indonesian' && $scope.spouseMandatory) {

            $scope.IDLength = 16;
            $scope.chkSpouseSeumurHidup = true;
            $scope.SpouseDisabledSeumurHidup = true;
            $scope.CIFInvestor.SpouseNationality = 102;
            $scope.CIFInvestor.SpouseIDCardExpiredDate = new Date(9998, 11, 31);
        }
        else if ($scope.SpouseKewarganegaraan == 'Lainnya / Others') {

            $scope.IDLength = 8;
            $scope.chkSpouseSeumurHidup = false;
            $scope.SpouseDisabledSeumurHidup = true;
            $scope.CIFInvestor.SpouseNationality = 0;
            $scope.CIFInvestor.SpouseIDCardExpiredDate = '';
        }
    }

    $scope.questionRDNchange = function () {

        $scope.OPBBCA.occupation = '';
        $scope.OPBBCA.occupationText = '';
        $scope.OPBBCA.position = '';
        $scope.OPBBCA.positionText = '';
        $scope.OPBBCA.business = '';
        $scope.OPBBCA.businessText = '';

        $scope.OPBOTHER.occupation = '';
        $scope.OPBOTHER.occupationText = '';
        $scope.OPBOTHER.position = '';
        $scope.OPBOTHER.positionText = '';
        $scope.OPBOTHER.business = '';
        $scope.OPBOTHER.businessText = '';

        $scope.CIFInvestor.BankName = "";
        $scope.disableBank = false;

        if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

            $scope.bankpribadi = "BANK CENTRAL ASIA";
            $scope.disableBank = true;
        }
    };

    
   

    $scope.changeSpouseMandatory = function (param) {

        if (param) {

            $scope.spouseMandatory = true;
        } else {
            let flag = false;

            if ($scope.OPBBCA) {

                if ($scope.OPBBCA.occupation.key == 1 || $scope.OPBBCA.occupation.key == 2) {

                    flag = true;
                    $scope.spouseMandatory2 = true;
                    $scope.spouseMandatory1 = false
                }
            }

            if($scope.OPCIMB)
            {
                if($scope.OPCIMB.occupation.key == 11725 || $scope.OPCIMB.occupation.key == 11726 || $scope.OPCIMB.occupation.key == 11727 || $scope.OPCIMB.occupation.key == 11728)
                {
                    flag = true;
                    $scope.spouseMandatory2 = true;
                    $scope.spouseMandatory1 = false
                }
            }

            if ($scope.CIFInvestor.QuestionRDN == 4) {
                if ($scope.CIFInvestor.Occupation == 9 || $scope.CIFInvestor.Occupation == 18) {
                    flag = true;
                    $scope.spouseMandatory2 = true;
                    $scope.spouseMandatory1 = false
                }
            }

            if ($scope.OPBOTHER) {

                if ($scope.OPBOTHER.CIFLookupInteger == 4 || $scope.OPBOTHER.CIFLookupInteger == 6) {

                    flag = true;
                    $scope.spouseMandatory2 = true;
                    $scope.spouseMandatory1 = false;
                }

            }

            if ($scope.selectedFundSource.indexOf(7) > -1) {

                flag = true;
                $scope.spouseMandatory2 = true;
                $scope.spouseMandatory1 = false;
            }

            if ($scope.selectedFundSource.indexOf(6) > -1) {

                flag = true;
                $scope.spouseMandatory1 = true;
                $scope.spouseMandatory2 = false;
            }

            if (!flag) {

                $scope.CIFInvestor.SpouseCompanyName = '';
                $scope.CIFInvestor.SpouseIncomePerAnnum = '';
                $scope.CIFInvestor.SpouseOccupation = '';
                $scope.CIFInvestor.SpousePosition = '';
                $scope.CIFInvestor.SpouseNatureOfBusiness = '';
                $scope.CIFInvestor.SpouseCompanyCity = '';
                $scope.CIFInvestor.SpouseCompanyPostalCode = '';
                $scope.CIFInvestor.SpouseCompanyAddress = '';
                $scope.CIFInvestor.SpouseFundSource = '';

                $scope.SpouseCompanyCitySelected = '';
                $scope.selectedSpouseFundSource = [];

                $scope.OPSPOUSE.occupation = '';
                $scope.OPSPOUSE.occupationText = '';
                $scope.OPSPOUSE.position = '';
                $scope.OPSPOUSE.business = '';
            }

            $scope.spouseMandatory = flag;
        }
    }

    $scope.NPWPNumber = function () {
        if ($scope.CIFInvestor.QuestionNPWP == 1) {
            $scope.CIFInvestor.NPWPNumber = $scope.CIFInvestor.IDCardNumber
            $scope.disabledNPWPNumber = true;
        }
    };

    $scope.updateNPWP = function () {

        if ($scope.CIFInvestor.NPWPNumber) {

            if (+$scope.QuestionNPWP == 1) {

                $scope.CIFInvestor.NPWPNumber;
            } else {

                $scope.CIFInvestor.NPWPReason;
                $scope.CIFInvestor.NPWPNumber = '';
            }
        }
    };

    $scope.updateNPWPSpouse = function () {

        if ($scope.CIFInvestor.NPWPNumber) {

            if (+$scope.QuestionNPWP == 1) {

                $scope.CIFInvestor.NPWPNumber;
            } else {

                $scope.CIFInvestor.NPWPReason;
                $scope.CIFInvestor.NPWPNumber = '';
            }
        }
    };

    $scope.occupationChange_BRI = function () {

        if ($scope.CIFInvestor.Occupation) {
            if ($scope.CIFInvestor.Occupation == 9 || $scope.CIFInvestor.Occupation == 18 || $scope.CIFInvestor.Occupation == 12) {
                $scope.changeSpouseMandatory(true);
                $scope.MandatoryBRI = false;
                $scope.FundSourceSpouse = true;
                if ($scope.CIFInvestor.Occupation == 9) {
                    $scope.CIFInvestor.CompanyName = 'IBU RUMAH TANGGA';
                }
                else {
                    $scope.CIFInvestor.CompanyName = '';
                }
            } else {
                $scope.MandatoryBRI = true;
                $scope.CIFInvestor.CompanyName = '';
                $scope.changeSpouseMandatory(false);
            }
        }


    };

    $scope.occupationChange_BCA = function () {

        if ($scope.OPBBCA.occupation) {

            $scope.OPBBCA.occupationText = '';
            $scope.OPBBCA.position = 0;
            $scope.OPBBCA.positionText = '';
            $scope.OPBBCA.business = 0;
            $scope.OPBBCA.businessText = '';

            if ($scope.OPBBCA.occupation.key == 1 || $scope.OPBBCA.occupation.key == 2)
                $scope.changeSpouseMandatory(true);
            else
                $scope.changeSpouseMandatory();

            appFactory.getData(`/service/client.svc/GetJabatan?Pekerjaan=${$scope.OPBBCA.occupation.key}`).then(function (data) {

                if (data.status == 200) {

                    $scope.listjabatan_BCA = data.data.d;

                    if ($scope.listjabatan_BCA.length) {
                        $scope.OPBBCA.positionText = '';
                        $scope.OPBBCA.position = $scope.listjabatan_BCA[0];

                        $scope.positionChange_BCA();
                    }
                }
            });
        }
    };

    $scope.positionChange_BCA = function () {

        appFactory.getData(`/service/client.svc/GetBidangUsaha?Jabatan=${$scope.OPBBCA.position.key}&Pekerjaan=${$scope.OPBBCA.occupation.key}`).then(function (data) {

            if (data.status == 200) {

                $scope.listusaha_BCA = data.data.d;

                if ($scope.listusaha_BCA.length) {

                    $scope.OPBBCA.businessText = '';
                    $scope.OPBBCA.business = $scope.listusaha_BCA[0];
                }
            }
        });
    };

    $scope.occupationChange_OTHER = function () {

        if ($scope.OPBOTHER.occupation) {

            $scope.OPBOTHER.occupationText = '';
            $scope.OPBOTHER.position = '';
            $scope.OPBOTHER.positionText = '';
            $scope.OPBOTHER.business = '';
            $scope.OPBOTHER.businessText = '';

            if ($scope.OPBOTHER.occupation == '4' || $scope.OPBOTHER.occupation == '6')
                $scope.changeSpouseMandatory(true);
            else
                $scope.changeSpouseMandatory();
        }
    }

    $scope.occupationChange_CIMB = function()
    {
        if ($scope.OPCIMB.occupation)
        {
            if ($scope.OPCIMB.occupation.key == 11725 || $scope.OPCIMB.occupation.key == 11726 || $scope.OPCIMB.occupation.key == 11727 || $scope.OPCIMB.occupation.key == 11728)
            {
                $scope.changeSpouseMandatory(true);
            }
            else{
                $scope.changeSpouseMandatory();
            }
        }
    }

    $scope.toggleFundSourceItem = function (fundsource) {

        let indexCIFLookupInteger = $scope.selectedFundSource.indexOf(fundsource.CIFLookupInteger);

        if (indexCIFLookupInteger > -1)
            $scope.selectedFundSource.splice(indexCIFLookupInteger, 1);
        else
            $scope.selectedFundSource.push(fundsource.CIFLookupInteger);

        if ($scope.selectedFundSource.indexOf(1) < 0)
            $scope.CIFInvestor.FundSourceText = '';

        $scope.changeSpouseMandatory();
    }

    $scope.toggleSpouseFundSourceItem = function (fundsource) {

        $scope.CIFInvestor.SpouseFundSource = '';
        let indexCIFLookupInteger = $scope.selectedSpouseFundSource.indexOf(fundsource.CIFLookupInteger);

        if (indexCIFLookupInteger > -1)
            $scope.selectedSpouseFundSource.splice(indexCIFLookupInteger, 1);
        else
            $scope.selectedSpouseFundSource.push(fundsource.CIFLookupInteger);

        if ($scope.selectedSpouseFundSource.indexOf(1) < 0)
            $scope.CIFInvestor.SpouseFundSourceText = '';
    }

    $scope.prepareData = function () {

        $scope.CIFInvestor.Occupation = Number($scope.CIFInvestor.Occupation);

        if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

            $scope.CIFInvestor.BankName = $scope.bankpribadi;
            $scope.CIFInvestor.Occupation = $scope.OPBBCA.occupation.key;
            $scope.CIFInvestor.OccupationText = $scope.OPBBCA.occupationText;
            $scope.CIFInvestor.Position = $scope.OPBBCA.position.key;
            $scope.CIFInvestor.PositionText = $scope.OPBBCA.positionText;
            $scope.CIFInvestor.NatureOfBusiness = $scope.OPBBCA.business.key;
            $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBBCA.businessText;
        }else if ($scope.CIFInvestor.QuestionRDN == '9' || $scope.CIFInvestor.QuestionRDN == 9) {

            $scope.CIFInvestor.BankName = $scope.bankpribadi;
            $scope.CIFInvestor.Occupation = $scope.OPCIMB.occupation.key;
            $scope.CIFInvestor.OccupationText = '';
            $scope.CIFInvestor.Position = $scope.OPCIMB.position.key;
            $scope.CIFInvestor.PositionText = '';
            $scope.CIFInvestor.NatureOfBusiness = 0;
            $scope.CIFInvestor.NatureOfBusinessText = $scope.OPCIMB.business.value;
        } else if ($scope.CIFInvestor.QuestionRDN == 4 && $scope.CIFInvestor.IsBRIVersion == 1) {
            if ($scope.CIFInvestor.Occupation == 9) {
                $scope.CIFInvestor.Position = 69;
                $scope.CIFInvestor.NatureOfBusinessText = 'Ibu Rumah Tangga';

            } else if ($scope.CIFInvestor.Occupation == 12) {
                $scope.CIFInvestor.Position = 70;
                $scope.CIFInvestor.NatureOfBusinessText = 'Pelajar';

            } else {
                $scope.CIFInvestor.Occupation = $scope.CIFInvestor.Occupation;
                $scope.CIFInvestor.Position = $scope.CIFInvestor.Position;
                $scope.CIFInvestor.NatureOfBusinessText = $scope.CIFInvestor.NatureOfBusinessText;
            }

            if ($scope.CIFInvestor.FundSource != 3) {
                $scope.CIFInvestor.FundSourceText = '';
            }

            $scope.CIFInvestor.NatureOfBusiness = 0;
            $scope.CIFInvestor.FundSource = $scope.FundSourceBRI;

            console.log($scope.CIFInvestor.FundSource)
            console.log($scope.CIFInvestor.FundSourceText)
            //$scope.CIFInvestor.FundSource = $scope.CIFInvestor.FundSource.toString();
        } else {

            $scope.CIFInvestor.Occupation = Number($scope.OPBOTHER.occupation);
            $scope.CIFInvestor.BankName = $scope.bankpribadi;
            $scope.CIFInvestor.OccupationText = $scope.OPBOTHER.occupationText;
            $scope.CIFInvestor.Position = 0;
            $scope.CIFInvestor.NatureOfBusiness = 0;

            if ($scope.OPBOTHER.occupation == '4') {

                $scope.CIFInvestor.PositionText = '';
                $scope.CIFInvestor.NatureOfBusinessText = '';
            } else {

                $scope.CIFInvestor.PositionText = $scope.OPBOTHER.positionText;
                $scope.CIFInvestor.NatureOfBusiness = 0;
                $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBOTHER.businessText;
            }
        }

        if ($scope.spouseMandatory) {

            $scope.CIFInvestor.SpouseOccupation = Number($scope.OPSPOUSE.occupation);
            $scope.CIFInvestor.SpouseOccupationText = $scope.SpouseOccupationText;
            $scope.CIFInvestor.SpousePosition = $scope.OPSPOUSE.position;
            $scope.CIFInvestor.SpouseNatureOfBusiness = ($scope.OPSPOUSE.business);
            //$scope.CIFInvestor.SpouseCompanyCity = Number($scope.SpouseCompanyCitySelected);
        } else {

            $scope.CIFInvestor.SpouseIncomePerAnnum = 0;
            $scope.CIFInvestor.SpouseOccupation = 0;
            $scope.CIFInvestor.SpouseCompanyCity = 0;
        }

        if ($scope.CIFInvestor.QuestionRDN == 1) {
            if ($scope.selectedFundSource) {

                $scope.CIFInvestor.FundSource = '';

                for (var i = 0; i < $scope.selectedFundSource.length; i++) {

                    if ($scope.CIFInvestor.FundSource.length > 0)
                        $scope.CIFInvestor.FundSource += ',';
                    $scope.CIFInvestor.FundSource += $scope.selectedFundSource[i];
                }
            }
        }


        if ($scope.selectedSpouseFundSource) {

            $scope.CIFInvestor.SpouseFundSource = '';

            for (var i = 0; i < $scope.selectedSpouseFundSource.length; i++) {

                if ($scope.CIFInvestor.SpouseFundSource.length > 0)
                    $scope.CIFInvestor.SpouseFundSource += ',';
                $scope.CIFInvestor.SpouseFundSource += $scope.selectedSpouseFundSource[i];
            }
        }
    };


    $scope.submit = function () {
        $scope.prepareData();
        // dynamic sweet alert post to app.js
        // 1: set the url of post or get request
        // 2: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 3: set the postdata to $http request = GET : {} / POST { yourdata : data }
        // 4: set the method to $http request = "GET" / "POST"
        // 5: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 6: if success or no error returns then...
        var urlsvc = '/service/client.svc/SaveCIF'; // 1 
        var preconfirmtranslate = "submitCif1"; // 2
        var postData = { cifdata: $scope.CIFInvestor } // 3
        var method = "POST" // 4
        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

            if (issuccess) // 6
                $window.location.href = "#/cif/data-pekerjaan";
            else {
                Swal.fire('Failed', data.data.d.response, 'error');
            }
        });
    }

    $scope.submit = function () {
        $scope.prepareData();
        var finished = 0;
      
        $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah data yang diisi sudah sesuai?")
        .then((result) => {
            if (result.value) {
                $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                $http({
                    method: 'POST',
                    url: '/service/client.svc/SaveCIF',
                    data:
                        {
                            cifdata: $scope.CIFInvestor
                        },
                }).then(function (data) {

                    if (data.data.d.result) {
                        Swal.close();
                        $window.location.href = "#/cif/data-pendukung";
                    }
                    else {
                        Swal.fire('Failed', data.data.d.response, 'error');
                    }
                }, function (error) {
                    Swal.fire('Error', 'error - Please check your connection', 'error');
                });
            }
        });

    }


    $scope.validationinput = function () {

        var errorForm = $scope.myForm.$error.required
        var validation = $scope.myForm.$valid;
        var message = [];
        //console.log('error :', errorForm);

        if (errorForm) {
            for (let i = 0; i < errorForm.length; i++) {
                //message += errorForm[i].$name + " , ";
                message.push(errorForm[i].$name);
            }
        }

        //console.log($scope.CIFInvestor.BankStatus);

        //PROSES VALIDATION
        if (validation == false) {
            console.log("error : " + message);

            var SWALtranslate = $scope.SWALtranslate('validationinput');
            Swal.fire({
                title: SWALtranslate.title,
                text: SWALtranslate.message,
                imageUrl: 'img/collection/wrong.png',
                imageAlt: 'Preparation',
                imageHeight: 250,
                animation: false
            });
        }

    }


    var allPromise = $q.all([

          appFactory.getData(`/service/client.svc/GetCIFCountry`).then(function (data) {

              if (data.status == 200) {

                  $scope.ListNationality = data.data.d;
              }
          }),

        appFactory.getData(`/service/client.svc/GetCIFProvinceCity`).then(function (data) {

            if (data.status == 200) {

                $scope.ListProvinceCity = data.data.d;
            }
        }),

         appFactory.getData(`/service/client.svc/GetCIFLookupBRI`).then(function (data) {

             if (data.status == 200) {

                 $scope.ListBRILookup = data.data.d;
                 if ($scope.ListBRILookup) {
                     $scope.ListBRIOccupation = $filter('filter')($scope.ListBRILookup, { BRI_ID: 'Occupation' }, true);
                     $scope.ListBRIPosition = $filter('filter')($scope.ListBRILookup, { BRI_ID: 'Position' }, true);
                     $scope.ListBRIFundSource = $filter('filter')($scope.ListBRILookup, { BRI_ID: 'FundSource' }, true);
                 }
             }
         }),

        appFactory.getData(`/service/client.svc/GetCIFLookup`).then(function (data) {

            if (data.status == 200) {

                $scope.ListLookup = data.data.d;

                if ($scope.ListLookup) {

                    $scope.ListOccupation = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Occupation' }, true);
                    $scope.ListSpouseIncome = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                    $scope.ListFundSource = $filter('filter')($scope.ListLookup, { CIFLookupID: 'FundSource' }, true);
                    $scope.ListIncomePerAnnum = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                    $scope.ListMarital = $filter('filter')($scope.ListLookup, { CIFLookupID: 'MaritalStatus' }, true);
                    
                }
            }
        }),

        appFactory.getData(`/service/client.svc/GetCIFBank`).then(function (data) {

            if (data.status == 200) {

                $scope.ListBank = data.data.d;
            }
        }),

        appFactory.getData(`/service/client.svc/GetCIFPekerjaan`).then(function (data) {

            if (data.status == 200) {

                $scope.listpekerjaan_BCA = data.data.d;
            }
        }),

         appFactory.getData(`/service/client.svc/GetCIFPekerjaanCIMB`).then(function (data) {

             if (data.status == 200) {

                 $scope.listpekerjaan_CIMB = data.data.d;
             }
         }),


        appFactory.getData(`/service/client.svc/GetJabatan`).then(function (data) {

            if (data.status == 200) {

                $scope.listposition_BCA = data.data.d;
            }
        }),

         appFactory.getData(`/service/client.svc/GetJabatanCIMB`).then(function (data) {

             if (data.status == 200) {

                 $scope.listposition_CIMB = data.data.d;
             }
         }),

        appFactory.getData(`/service/client.svc/GetBidangUsaha`).then(function (data) {

            if (data.status == 200) {

                $scope.listnature_BCA = data.data.d;
            }
        }),

        appFactory.getData(`/service/client.svc/GetBidangUsahaCIMB`).then(function (data) {

            if (data.status == 200) {

                $scope.listnature_CIMB = data.data.d;
            }
        })
    ]);

    allPromise.then(function () {

        appFactory.getData(`/service/client.svc/getCIF`).then(function (data) {

            if (data.status == 200) {

                if (data.data.d != null) {

                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;
                    $scope.CIFInvestor.Stage = 2;
                    if ($scope.CIFInvestor.QuestionRDN == 0) {

                        $scope.CIFInvestor.QuestionRDN = '';
                    }

                    if ($scope.CIFInvestor.BankOwner == '' || !$scope.CIFInvestor.BankOwner)
                        $scope.CIFInvestor.BankOwner = $scope.CIFInvestor.FirstName;

                    $scope.FundSourceBRI = $scope.CIFInvestor.FundSource

                    $scope.bankpribadi = $scope.CIFInvestor.BankName;

                    if ($scope.CIFInvestor.SpouseCompanyCity)
                        $scope.SpouseCompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.DomicileCity }, true)[0];

                    if ($scope.CIFInvestor.CompanyCity)
                        $scope.CompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.CompanyCity }, true)[0];

                    if (data.data.d.CompanyCity) {

                        $scope.CompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.CompanyCity }, true)[0];
                        if ($scope.CIFInvestor.QuestionRDN == 1 || $scope.CIFInvestor.QuestionRDN == 4) {

                            appFactory.getData(`/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=${data.data.d.CompanyCity}`).then(function (data) {

                                if (data.status == 200) {

                                    $scope.ListKecamatanCompany = data.data.d;
                                    if ($scope.ListKecamatanCompany)
                                        $scope.ListKelurahanCompany = $filter('filter')($scope.ListKecamatanCompany, { Kecamatan: $scope.CIFInvestor.CompanyKecamatan }, true);
                                }
                            })
                        }

                        if ($scope.CIFInvestor.QuestionRDN == 9) {

                            appFactory.getData(`/service/client.svc/GetCIFKecamatanCIMBByCityNID?CIFCityNID=${data.data.d.CompanyCity}`).then(function (data) {

                                if (data.status == 200) {

                                    $scope.ListKecamatanCompany = data.data.d;
                                    if ($scope.ListKecamatanCompany)
                                        $scope.ListKelurahanCompany = $filter('filter')($scope.ListKecamatanCompany, { Kecamatan: $scope.CIFInvestor.CompanyKecamatan }, true);
                                }
                            })
                        }
                    }

                    if (data.data.d.SpouseIDCardCity) {

                        $scope.SpouseIDCardCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.SpouseIDCardCity }, true)[0];
                        if ($scope.CIFInvestor.QuestionRDN == 1 || $scope.CIFInvestor.QuestionRDN == 4) {

                            appFactory.getData(`/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=${data.data.d.SpouseIDCardCity}`).then(function (data) {

                                if (data.status == 200) {
                                    console.log('kec')
                                    $scope.ListKecamatanSpouse = data.data.d;
                                    if ($scope.ListKecamatanSpouse)
                                        $scope.ListKelurahanSpouse = $filter('filter')($scope.ListKecamatanSpouse, { Kecamatan: $scope.CIFInvestor.SpouseIDCardKecamatan }, true);
                                }
                            })
                        }

                        if ($scope.CIFInvestor.QuestionRDN == 9) {

                            appFactory.getData(`/service/client.svc/GetCIFKecamatanCIMBByCityNID?CIFCityNID=${data.data.d.SpouseIDCardCity}`).then(function (data) {

                                if (data.status == 200) {

                                    $scope.ListKecamatanSpouse = data.data.d;
                                    if ($scope.ListKecamatanSpouse)
                                        $scope.ListKelurahanSpouse = $filter('filter')($scope.ListKecamatanSpouse, { Kecamatan: $scope.CIFInvestor.SpouseIDCardKecamatan }, true);
                                }
                            })
                        }
                    }

                    if (data.data.d.SpouseIDCardExpiredDate)
                        $scope.CIFInvestor.SpouseIDCardExpiredDate = new Date(data.data.d.SpouseIDCardExpiredDate);

                    if (data.data.d.SpouseBirthDate)
                        $scope.CIFInvestor.SpouseBirthDate = new Date(data.data.d.SpouseBirthDate);


                    if ($scope.CIFInvestor.QuestionRDN) {

                        if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

                            $scope.OPBBCA.occupationText = $scope.CIFInvestor.OccupationText;
                            $scope.OPBBCA.positionText = $scope.CIFInvestor.PositionText;
                            $scope.OPBBCA.businessText = $scope.CIFInvestor.NatureOfBusinessText;

                            if ($scope.CIFInvestor.Occupation && $scope.CIFInvestor.Occupation > 0) {

                                $scope.OPBBCA.occupation = $filter('filter')($scope.listpekerjaan_BCA, { key: $scope.CIFInvestor.Occupation }, true)[0];

                                appFactory.getData(`/service/client.svc/GetJabatan?Pekerjaan=${$scope.OPBBCA.occupation.key}`).then(function (data) {

                                    if (data.status == 200) {

                                        $scope.listjabatan_BCA = data.data.d;

                                        if ($scope.listjabatan_BCA.length) {

                                            if ($scope.CIFInvestor.Position && $scope.CIFInvestor.Position > 0) {

                                                $scope.OPBBCA.position = $filter('filter')($scope.listjabatan_BCA, { key: $scope.CIFInvestor.Position }, true)[0];

                                                appFactory.getData(`/service/client.svc/GetBidangUsaha?Jabatan=${$scope.OPBBCA.position.key}&Pekerjaan=${$scope.OPBBCA.occupation.key}`).then(function (data) {

                                                    if (data.status == 200) {

                                                        $scope.listusaha_BCA = data.data.d;

                                                        if ($scope.listusaha_BCA.length) {

                                                            if ($scope.CIFInvestor.NatureOfBusiness != null)
                                                                $scope.OPBBCA.business = $filter('filter')($scope.listusaha_BCA, { key: $scope.CIFInvestor.NatureOfBusiness }, true)[0];
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                    }
                                })
                            }
                        }else if ($scope.CIFInvestor.QuestionRDN == '9' || $scope.CIFInvestor.QuestionRDN == 9) {

                            if ($scope.CIFInvestor.Occupation && $scope.CIFInvestor.Occupation > 0) {

                                $scope.OPCIMB.occupation = $filter('filter')($scope.listpekerjaan_CIMB, { key: $scope.CIFInvestor.Occupation }, true)[0];
                                $scope.OPCIMB.position = $filter('filter')($scope.listposition_CIMB, { key: $scope.CIFInvestor.Position }, true)[0];
                                $scope.OPCIMB.business = $filter('filter')($scope.listnature_CIMB, { value: $scope.CIFInvestor.NatureOfBusinessText }, true)[0];

                            }
                        } else if ($scope.CIFInvestor.QuestionRDN == 4) {


                            if (data.data.d.BRIPeriodWork)
                                $scope.CIFInvestor.BRIPeriodWork = new Date(data.data.d.BRIPeriodWork);

                            if ($scope.CIFInvestor.Occupation == 9 || $scope.CIFInvestor.Occupation == 12 || $scope.CIFInvestor.Occupation == 18) {
                                $scope.MandatoryBRI = false;
                                $scope.spouseMandatory = true;
                                $scope.FundSourceSpouse = true;
                                $scope.OPSPOUSE.occupation = $scope.CIFInvestor.SpouseOccupation;
                                $scope.OPSPOUSE.position = $scope.CIFInvestor.SpousePosition;
                                $scope.OPSPOUSE.business = $scope.CIFInvestor.SpouseNatureOfBusiness;
                                $scope.OPSPOUSE.occupationText = $scope.CIFInvestor.SpouseOccupationText;
                            } else {
                                $scope.MandatoryBRI = true;
                            }
                        } else {

                            $scope.OPBOTHER.occupation = $scope.CIFInvestor.Occupation;
                            $scope.OPBOTHER.occupationText = $scope.CIFInvestor.OccupationText;
                            $scope.OPBOTHER.position = $scope.CIFInvestor.Position;
                            $scope.OPBOTHER.positionText = $scope.CIFInvestor.PositionText;
                            $scope.OPBOTHER.business = $scope.CIFInvestor.NatureOfBusiness;
                            $scope.OPBOTHER.businessText = $scope.CIFInvestor.NatureOfBusinessText;
                        }
                    }


                    if (data.data.d.SpouseNationality) {

                        if (data.data.d.SpouseNationality == 102) {

                            $scope.IDLength = 16;
                            $scope.chkSpouseSeumurHidup = true;
                            $scope.DisabledSeumurHidup = true;
                            $scope.CIFInvestor.SpouseNationality = 102;
                            $scope.SpouseKewarganegaraan = $scope.SpouseKewarganegaraanOption[0];
                            $scope.CIFInvestor.SpouseIDCardExpiredDate = new Date(9998, 11, 31);
                        } else {

                            $scope.IDLength = 8;
                            $scope.chkSpouseSeumurHidup = false;
                            $scope.DisabledSeumurHidup = true;
                            $scope.SpouseKewarganegaraan = $scope.SpouseKewarganegaraanOption[1];
                            $scope.SpouseNationalitySelected = $filter('filter')($scope.ListNationality, { CIFCountryNID: data.data.d.SpouseNationality }, true)[0];

                            if (data.data.d.SpouseIDCardExpiredDate)
                                $scope.CIFInvestor.SpouseIDCardExpiredDate = new Date(data.data.d.SpouseIDCardExpiredDate);
                        }
                    } else {
                        $scope.SpouseKewarganegaraanChange();
                    }

                    //if ($scope.CIFInvestor.SpouseCompanyCity == 0)
                    //    $scope.CIFInvestor.SpouseCompanyCity = null;

                    //if ($scope.CIFInvestor.CompanyCity == 0)
                    //    $scope.CIFInvestor.CompanyCity = null;

                    //if ($scope.CIFInvestor.QuestionNPWP == 0)
                    //    $scope.CIFInvestor.QuestionNPWP = null;

                    //if ($scope.CIFInvestor.SpouseQuestionNPWP == 0)
                    //    $scope.CIFInvestor.SpouseQuestionNPWP = null;

                    //if ($scope.CIFInvestor.IncomePerAnnum == 0)
                    //    $scope.CIFInvestor.IncomePerAnnum = null;

                    //if ($scope.CIFInvestor.SpouseMaritalStatus == 0)
                    //    $scope.CIFInvestor.SpouseMaritalStatus = null;

                    if ($scope.CIFInvestor.FundSource) {

                        $scope.selectedFundSource = [];
                        let temp = $scope.CIFInvestor.FundSource.split(',');

                        for (var i = 0; i < temp.length; i++) {

                            $scope.selectedFundSource.push(Number(temp[i]));
                        }
                    }
                    if ($scope.CIFInvestor.SpouseFundSource) {

                        $scope.selectedSpouseFundSource = [];
                        let temp = $scope.CIFInvestor.SpouseFundSource.split(',');

                        for (var i = 0; i < temp.length; i++) {

                            $scope.selectedSpouseFundSource.push(Number(temp[i]));
                        }
                    }

                    if ($scope.CIFInvestor.SpouseOccupation == 0)
                        $scope.CIFInvestor.SpouseOccupation = '';

                    if ($scope.CIFInvestor.SpouseIncomePerAnnum == 0)
                        $scope.CIFInvestor.SpouseIncomePerAnnum = '';

                    $scope.changeSpouseMandatory();
                    $scope.OPSPOUSE.occupation = $scope.CIFInvestor.SpouseOccupation;
                    $scope.OPSPOUSE.occupationText = $scope.CIFInvestor.SpouseOccupationText;
                    $scope.OPSPOUSE.position = $scope.CIFInvestor.SpousePosition;
                    $scope.OPSPOUSE.business = $scope.CIFInvestor.SpouseNatureOfBusiness;
                } 
            }
        })
    });
}]);